import { type FC } from 'react';
import { Button, Stack } from '@mantine/core';
import { type PayinCheck } from '~/entities/payin';
import { Check } from './components';

export interface ShowChecksProps {
    checks: PayinCheck[];
    onCancel?: VoidFunction;
}

export const ShowChecks: FC<ShowChecksProps> = ({ checks, onCancel }) => {
    return (
        <Stack gap={16}>
            <Stack gap='md'>
                {checks?.map((check) => {
                    return <Check check={check} />;
                })}
            </Stack>

            {onCancel && (
                <Button
                    title='Закрыть'
                    onClick={onCancel}
                >
                    Закрыть
                </Button>
            )}
        </Stack>
    );
};
